import React from "react";
import Modal from "../../../../Common/Modal";
import MtiButton from "../../../../Buttons/MtiButton";
import "./SlotCorrectionProgressModal";

type Props = {
  show: boolean;
  onHide: () => void;
};

export default function SlotCorrectionSuccessModal({ show, onHide }: Props) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      className="auto-calibration-progress-modal done"
    >
      <Modal.Header
        title={"Correction Slot"}
        hideButtonEnabled={false}
        className="auto-calibration-progress-header"
      />
      <Modal.Body className="auto-calibration-progress-body">
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4998 70.0837C54.5997 70.0837 70.0832 54.6002 70.0832 35.5003C70.0832 16.4005 54.5997 0.916992 35.4998 0.916992C16.4 0.916992 0.916504 16.4005 0.916504 35.5003C0.916504 54.6002 16.4 70.0837 35.4998 70.0837ZM18.2082 32.042L11.2915 38.9587L28.5832 56.2503L59.7082 25.1253L52.7915 18.2087L28.5832 42.417L18.2082 32.042Z"
            fill="#00A84C"
          />
        </svg>

        <div className="progress-title">
          <p>The slot correction has been performed successfully</p>
        </div>
        <div className="progress-subtittle">
          You can access the result once this dialog is dismised
        </div>
        <MtiButton
          variant="primary"
          size="large"
          onClick={onHide}
          style={{
            width: 125,
            alignSelf: "flex-end",
          }}
        >
          <span>OK</span>
        </MtiButton>
      </Modal.Body>
    </Modal>
  );
}
